import { gql } from '@apollo/client';

export default gql`
  mutation ResolveMatchIssues($input: ResolveMatchIssuesInput!) {
    resolveMatchIssues(input: $input) {
      id
    }
  }
`;
